export const fr = {
  "auth.signIn": "Connexion",
  "auth.signOut": "Déconnexion",
  "auth.label": "Accès membres",
  "auth.title": "Connectez-vous pour voir les véhicules",
  "auth.sub": "Stock en direct de Corée et du Japon, avec le prix rendu dans votre pays. Indiquez votre e-mail et nous vous envoyons un lien — aucun mot de passe à inventer ni à retenir.",
  "auth.send": "Envoyez-moi le lien",
  "auth.sending": "Envoi…",
  "auth.why": "Votre adresse nous sert à envoyer le lien et à répondre à vos demandes. Rien d'autre, et jamais à quiconque.",
  "auth.sentLabel": "Consultez votre boîte mail",
  "auth.sentTitle": "Le lien est parti",
  "auth.sentBody": "Nous avons envoyé un lien de connexion à {email}. Ouvrez-le sur cet appareil et c'est fait.",
  "auth.sentSpam": "Il devrait arriver en moins d'une minute. Sinon, regardez dans les indésirables — et vérifiez l'adresse saisie.",
  "auth.useAnother": "Utiliser une autre adresse",
  "auth.alreadyIn": "Vous êtes connecté",
  "auth.err.invalid_email": "Cela ne ressemble pas à une adresse e-mail.",
  "auth.err.too_many": "Trop de demandes de lien. Patientez quelques minutes.",
  "auth.err.mail_failed": "L'envoi a échoué pour le moment. Réessayez dans un instant.",
  "auth.err.link_expired": "Ce lien a expiré ou a déjà servi. En voici un nouveau.",
  "nav.stock": "Stock",
  "nav.auctions": "Enchères au Japon",
  "nav.calculator": "Calculateur d'importation",
  "nav.how": "Les étapes",
  "nav.contact": "Contact",
  "common.from": "de",
  "common.to": "à",
  "common.any": "Indifférent",
  "common.all": "Tous",
  "common.loading": "Chargement…",
  "common.showMore": "Voir plus",
  "common.showLess": "Voir moins",
  "common.reset": "Réinitialiser",
  "common.close": "Fermer",
  "common.back": "Retour",
  "common.km": "km",
  "common.year": "Année",
  "common.results": "{n} voitures",
  "common.noResults": "Aucune voiture ne correspond à ces filtres",
  "common.noResultsBody": "Élargissez la plage de prix ou d'années, ou retirez un filtre.",
  "common.estimate": "Estimation",
  "common.optional": "facultatif",
  "common.required": "obligatoire",
  "common.error": "Une erreur est survenue. Veuillez réessayer.",
  "common.retry": "Réessayer",
  "home.eyebrow": "Corée · Japon → Europe",
  "home.title": "Les voitures que l'Europe n'a jamais eues.",
  "home.sub": "Des voitures de sport et de prestige sélectionnées en Corée et au Japon, livrées chez vous. Destination : {country}. Chaque prix affiché inclut les droits de douane, la TVA et l'homologation.",
  "home.cta": "Voir le stock",
  "home.cta2": "Estimer une importation",
  "home.stat.cars": "voitures en annonce",
  "home.stat.makes": "marques",
  "home.stat.markets": "marchés d'origine",
  "home.why.title": "Pourquoi la Corée et le Japon",
  "home.why.kr.title": "En Corée, la conduite est à gauche",
  "home.why.kr.body": "En Corée, on roule à droite : chaque voiture coréenne a donc le volant à gauche. Elle peut circuler en France, en Suisse, en Allemagne et au Luxembourg sans conversion du poste de conduite. Un vaste marché au pouvoir d'achat élevé, où les voitures roulent beaucoup, hors du regard des acheteurs européens.",
  "home.why.jp.title": "Au Japon, les voitures restent soignées",
  "home.why.jp.body": "Les voitures au Japon sont réputées pour leur faible kilométrage et leur entretien soigné. Le système de notation des enchères permet d'en apprécier l'état avant d'enchérir. Nous ne proposons que des voitures à conduite à gauche : des sportives européennes d'exception vendues neuves au Japon.",
  "home.why.price.title": "Un prix, sans frais cachés",
  "home.why.price.body": "Chaque voiture affiche son coût jusque chez vous : achat, exportation, transport maritime, droits de douane, TVA, homologation et immatriculation. Pas de prix d'appel suivi de surprises au port.",
  "home.featured": "En stock actuellement",
  "home.featuredAll": "Voir tout le stock",
  "stock.title": "Stock",
  "stock.sub": "Stock actualisé de Corée et du Japon. Les prix affichés sont des estimations du prix rendu. Destination : {country}.",
  "stock.filters": "Filtres",
  "stock.sort": "Trier",
  "stock.sort.newest": "Ajouts les plus récents",
  "stock.sort.price_asc": "Prix rendu croissant",
  "stock.sort.price_desc": "Prix rendu décroissant",
  "stock.sort.year_desc": "Année : les plus récentes",
  "stock.sort.mileage_asc": "Kilométrage croissant",
  "stock.search": "Rechercher une marque, un modèle…",
  "stock.f.make": "Marque",
  "stock.f.model": "Modèle",
  "stock.f.source": "Marché",
  "stock.f.price": "Prix rendu",
  "stock.f.year": "Année",
  "stock.f.mileage": "Kilométrage maximal",
  "stock.f.fuel": "Carburant",
  "stock.f.body": "Carrosserie",
  "stock.f.transmission": "Boîte",
  "stock.f.steering": "Position du volant",
  "stock.f.photos": "Avec photos uniquement",
  "stock.f.search": "Rechercher",
  "stock.f.noMatch": "Aucun résultat",
  "stock.steering.LHD": "Conduite à gauche",
  "stock.steering.RHD": "Conduite à droite",
  "stock.steering.any": "Indifférent",
  "stock.clearAll": "Tout effacer",
  "car.landedIn": "Prix rendu — {country}",
  "car.estimateNote": "Estimation tout compris. La fourchette tient compte des postes chiffrés au cas par cas.",
  "car.listedAt": "Prix affiché sur le marché {market} :",
  "car.compare": "Comparer les pays",
  "car.compareNote": "Une même voiture, quatre destinations. La fiscalité et l'homologation varient fortement.",
  "car.cheapest": "Le moins cher",
  "car.breakdown": "Détail du prix",
  "car.leadTime": "Délai estimé",
  "car.leadTimeDays": "{n} jours",
  "car.enquire": "Se renseigner sur cette voiture",
  "car.enquireSub": "Nous confirmons le montant exact, inspectons la voiture et prenons tout en charge jusqu'à la livraison chez vous.",
  "car.specs": "Fiche technique",
  "car.spec.year": "Année",
  "car.spec.mileage": "Kilométrage",
  "car.spec.fuel": "Carburant",
  "car.spec.transmission": "Boîte",
  "car.spec.engine": "Moteur",
  "car.spec.body": "Carrosserie",
  "car.spec.colour": "Couleur",
  "car.spec.steering": "Position du volant",
  "car.spec.seats": "Places",
  "car.spec.location": "Localisation",
  "car.spec.seller": "Vendeur",
  "car.advisory": "Travaux éventuels supplémentaires",
  "car.advisoryNote": "Non compris dans le prix ci-dessus. Presque rien de cette liste ne s'applique à un véhicule donné : ce que révèle l'inspection est chiffré séparément avant tout engagement.",
  "car.advisoryUpTo": "jusqu'à {amount} si tout était nécessaire",
  "car.priceOnRequest": "Prix sur demande",
  "car.priceOnRequestBody": "Ce véhicule est annoncé sans prix public. Nous l'obtenons et vous chiffrons le prix rendu complet.",
  "car.daysOnMarket": "En vente depuis {n} jours",
  "car.daysOnMarketHelp": "Depuis combien de temps ce véhicule est annoncé sur son marché d'origine. Un véhicule en vente depuis des mois est généralement négociable.",
  "car.demoLot": "Lot exemple",
  "car.demoLotNote": "Lot de démonstration, pas une voiture achetable. Les enchères en direct ne sont pas encore connectées — les chiffres montrent comment un vrai lot serait chiffré.",

  // fuel
  "spec.fuel.petrol": "Essence",
  "spec.fuel.diesel": "Diesel",
  "spec.fuel.electric": "Électrique",
  "spec.fuel.hybrid": "Hybride",
  "spec.fuel.petrol-hybrid": "Hybride essence",
  "spec.fuel.diesel-hybrid": "Hybride diesel",
  "spec.fuel.petrol-lpg": "Essence / GPL",
  "spec.fuel.lpg": "GPL",
  "spec.fuel.hydrogen": "Hydrogène",

  // transmission
  "spec.transmission.automatic": "Automatique",
  "spec.transmission.manual": "Manuelle",
  "spec.transmission.semi-automatic": "Semi-automatique",
  "spec.transmission.cvt": "CVT",
  "spec.transmission.dct": "DCT",

  // body
  "spec.body.suv": "SUV",
  "spec.body.sports-car": "Voiture de sport",
  "spec.body.saloon": "Berline",
  "spec.body.coupe": "Coupé",
  "spec.body.convertible": "Cabriolet",
  "spec.body.estate": "Break",
  "spec.body.hatchback": "Hatchback",
  "spec.body.mpv": "Monospace",
  "spec.body.van": "Fourgon",
  "spec.body.truck": "Camion",
  "spec.body.city-car": "Citadine",
  "spec.body.small-car": "Petite citadine",
  "spec.body.compact": "Compacte",
  "spec.body.mid-size": "Berline intermédiaire",
  "spec.body.full-size": "Grande berline",

  // seller
  "spec.seller.dealer": "Concessionnaire",
  "spec.seller.private": "Particulier",
  "spec.seller.auction": "Enchère",
  "car.similar": "Voitures similaires",
  "car.assumptions": "Hypothèses retenues",
  "car.assumptionsNote": "Ces données ne sont pas publiées par la source. Nous les confirmons une à une avant d'établir une offre ferme : elles peuvent modifier le montant total.",
  "car.required": "Obligatoire",
  "car.quotedPerCar": "Chiffré par voiture",
  "car.import.hard": "Difficile à immatriculer en {country}",
  "car.import.hardTitle": "Difficile à immatriculer en {country}",
  "car.import.hardBody": "Ce véhicule est importable, mais l'homologation n'a rien de routinier et nous la chiffrons au cas par cas. Parlez-nous-en avant de vous engager.",
  "car.import.noTitle": "Non importable en {country}",
  "car.import.noBody": "Cette marque ne peut pas être immatriculée en {country} en import privé. Le véhicule reste affiché parce que vous avez suivi un lien — changez de pays ci-dessus, il est peut-être disponible.",
  "car.import.lightsTitle": "Véhicule japonais — phares à remplacer",
  "car.import.lightsBody": "Le Japon roule à gauche : les phares sont réglés pour la circulation à gauche et doivent être remplacés sur chaque véhicule qui en vient. La marque n'y change rien. Nous chiffrons ces travaux par voiture.",
  "car.gone": "Plus disponible",
  "car.goneBody": "Cette voiture n'est plus sur le marché. Décrivez-nous ce que vous cherchiez, nous en trouverons une autre.",
  "car.freight": "Mode de transport maritime",
  "car.freight.roro": "RoRo (le moins cher)",
  "car.freight.container_shared": "Conteneur partagé",
  "car.freight.container_exclusive": "Conteneur exclusif",
  "car.coc": "Le constructeur peut fournir un certificat de conformité européen (COC)",
  "car.cocHelp": "De nombreuses voitures européennes exportées neuves en Corée ou au Japon peuvent encore obtenir un COC. Il remplace la réception à titre isolé et réduit nettement le coût de l'homologation.",
  "car.confidence.placeholder": "Indicatif",
  "car.confidence.placeholderHelp": "À titre indicatif — chiffres en cours de vérification",
  "car.confidence.estimate": "Estimation",
  "car.confidence.estimateHelp": "Estimation — la plupart des chiffres sont vérifiés",
  "car.confidence.researched": "Documenté",
  "car.confidence.researchedHelp": "Chiffres documentés, à titre indicatif",
  "auctions.title": "Enchères au Japon",
  "auctions.sub": "Environ 30 000 voitures passent aux enchères au Japon chaque semaine. Nous enchérissons pour vous, après lecture et traduction de la fiche d'enchère.",
  "auctions.upcoming": "Lots à venir",
  "auctions.resultsTitle": "Ce que ces voitures partent réellement",
  "auctions.resultsSub": "Prix d'adjudication de ventes récentes au Japon — {n} résultats sur {models} modèles, du {from} au {to}. Limité aux marques que nous importons.",
  "auctions.resultsModel": "Modèle",
  "auctions.resultsSales": "Ventes",
  "auctions.resultsMedian": "Adjudication médiane",
  "auctions.grades": "Comprendre les notes d'enchères",
  "auctions.gradesSub": "Chaque voiture est inspectée et notée par la maison de ventes avant la vente. La note est le chiffre le plus important de la fiche.",
  "auctions.grade": "Note",
  "auctions.interior": "Intérieur",
  "auctions.lot": "Lot",
  "auctions.house": "Maison de ventes",
  "auctions.saleDate": "Date de vente",
  "auctions.estimate": "Prix d'adjudication estimé",
  "auctions.bidCta": "Nous confier une enchère",
  "auctions.notConfigured": "Les données d'enchères en direct ne sont pas encore connectées. Les lots ci-dessous sont des exemples représentatifs des voitures sur lesquelles nous enchérissons.",
  "enq.w.gradeMin": "Note d'enchère minimale",
  "enq.w.gradeMinHelp": "Le verdict de l'inspecteur sur la voiture. 4 et plus est le seuil habituel à l'import.",
  "enq.w.maxHammer": "Prix d'adjudication maximum (JPY)",
  "enq.w.maxHammerHelp": "Ce que nous ne devons pas dépasser. Tout ce qui suit — export, fret, douane, homologation — est chiffré avant votre engagement.",
  "auctions.bidTitle": "Enchérissez par notre intermédiaire",
  "auctions.bidSub": "Dites-nous la voiture et le plafond. Nous parcourons les salles chaque semaine, lisons et traduisons la fiche d'inspection, et revenons avec les lots qui méritent une enchère et leur prix rendu chez vous — avant toute enchère.",
  "auctions.bidNote": "Environ 30 000 voitures passent chaque semaine et un lot reste quelques minutes à l'écran. Un mandat permanent, c'est ainsi que l'on achète.",
  "auctions.samplesTitle": "À quoi ressemble un lot chiffré",
  "market.title": "Aux enchères japonaises",
  "market.headline": "Une {what} comparable est adjugée autour de {amount}, sur {n} ventes.",
  "market.spread": "La moitié se situe entre {band}.",
  "market.unsold": "{n} lots sur {total} n'ont pas atteint leur prix de réserve.",
  "market.unsold.one": "1 lot sur {total} n'a pas atteint son prix de réserve.",
  "market.basis": "Prix d'adjudication seul — hors frais d'enchères, export, fret, douane, TVA et homologation. C'est du prix de gros, d'où l'écart avec le prix rendu ci-dessus. Données tierces ; nous n'étions pas présents à ces ventes.",
  "market.period": "Ventes du {from} au {to}.",
  "market.scope.model": "{what}, toutes années confondues",
  "market.scope.years": "{what} de {from}–{to}",
  "auctions.sheetMarks": "Annotations de la fiche",
  "calc.title": "Calculateur d'importation",
  "calc.sub": "Vous avez déjà trouvé une voiture ? Saisissez son prix pour estimer son coût, livrée, homologuée et immatriculée.",
  "calc.price": "Prix sur le marché d'origine",
  "calc.origin": "Pays où se trouve la voiture",
  "calc.destination": "Votre pays",
  "calc.weight": "Masse en ordre de marche (kg)",
  "calc.co2": "CO₂ (g/km, WLTP)",
  "calc.cc": "Cylindrée (cm³)",
  "calc.year": "Année",
  "calc.compute": "Calculer",
  "calc.co2Help": "En France, le malus écologique peut dépasser le prix de la voiture. Sans la valeur de CO₂, l'estimation ne peut pas l'inclure.",
  "calc.weightHelp": "Détermine le malus au poids en France et les droits de douane en Suisse.",
  "how.title": "Les étapes",
  "how.s1.title": "Choisissez la voiture",
  "how.s1.body": "Consultez le stock actualisé de Corée et du Japon, ou dites-nous ce que vous cherchez. Nous le trouvons, y compris parmi les voitures qui ne font jamais l'objet d'une annonce publique.",
  "how.s2.title": "Nous l'inspectons",
  "how.s2.body": "Une inspection indépendante sur place, avant tout versement. Pour les lots aux enchères, nous lisons et traduisons d'abord la fiche d'enchère.",
  "how.s3.title": "Nous achetons et expédions",
  "how.s3.body": "Achat, radiation pour exportation, transport terrestre et fret maritime jusqu'à un port européen, avec une couverture d'assurance complète.",
  "how.s4.title": "Douane et homologation",
  "how.s4.body": "Droits de douane, TVA à l'importation, réception à titre isolé ou procédure avec COC selon votre pays, et modifications nécessaires pour que la voiture puisse y circuler légalement.",
  "how.s5.title": "Immatriculée et livrée",
  "how.s5.body": "Immatriculée à votre nom, munie de ses plaques et livrée chez vous, prête à rouler.",
  "how.homologation": "L'homologation par pays",
  "how.homologationSub": "La procédure permettant à une voiture de circuler légalement varie selon le pays. C'est l'étape que la plupart des importateurs maîtrisent mal.",
  "how.route": "Procédure",
  "how.cost": "Coût habituel",
  "how.leadTime": "Délai",
  "how.noCoc": "Sans certificat de conformité européen (COC)",
  "how.withCoc": "Avec certificat de conformité européen (COC)",
  "how.vat": "TVA à l'importation",
  "how.duty": "Droits de douane",
  "enq.title": "Demande de renseignements",
  "enq.name": "Nom",
  "enq.email": "E-mail",
  "enq.phone": "Téléphone",
  "enq.country": "Pays de livraison",
  "enq.message": "Informations utiles",
  "enq.messagePlaceholder": "Délai, budget, configuration, reprise…",
  "enq.submit": "Envoyer la demande",
  "enq.sending": "Envoi…",
  "enq.success": "Demande reçue",
  "enq.successBody": "Votre référence : {ref}. Nous vous répondrons sous un jour ouvré avec une offre ferme.",
  "enq.error": "L'envoi a échoué. Veuillez réessayer ou écrire à contact@apexcars.ch.",
  "enq.wanted": "Dites-nous ce que vous cherchez",
  "enq.wantedSub": "La plupart des voitures que nous vendons ne font jamais l'objet d'une annonce publique. Décrivez la voiture, nous la cherchons.",
  "enq.w.make": "Marque",
  "enq.w.model": "Modèle",
  "enq.w.yearFrom": "Année minimale",
  "enq.w.yearTo": "Année maximale",
  "enq.w.budget": "Budget (EUR)",
  "enq.w.mileage": "Kilométrage maximal (km)",
  "enq.w.colour": "Couleur",
  "enq.w.notes": "Configuration, options, critères non négociables",
  "enq.consent": "Nous utilisons vos coordonnées uniquement pour répondre à cette demande.",
  "footer.tagline": "Le goût de la recherche.",
  "footer.rights": "Tous droits réservés.",
  "footer.disclaimer": "Les prix affichés sont des estimations calculées à partir des règles publiées en matière de droits de douane, de TVA et d'homologation. Ils ne constituent pas une offre. Une offre ferme est établie après inspection du véhicule et vérification de ses documents.",
  "market.encar": "Corée du Sud",
  "market.goonet": "Japon",
  "market.jpauction": "Enchères au Japon",
  "common.noPhoto": "Photos indisponibles",
  "common.previous": "Précédent",
  "common.next": "Suivant",
  "common.photo": "Photo {n}",
  "common.language": "Langue",
  "common.menu": "Menu",
  "common.currency": "Devise",
  "stock.sourcePrice": "Prix d’origine en EUR",
  "car.noRepair": "Aucune réparation signalée",
  "car.repair": "Réparations signalées",
  "car.origin": "Origine préférentielle",
  "home.stat.days": "Durée moyenne de mise en vente",
};
